function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#333;}t"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Calendario");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M63.88,57.43A3.93,3.93,0,0,1,60,61.33H17a3.93,3.93,0,0,1-3.91-3.9v-39A3.93,3.93,0,0,1,17,14.48h3.9V11.55a4.9,4.9,0,0,1,4.88-4.88h2a4.89,4.89,0,0,1,4.88,4.88v2.93H44.36V11.55a4.89,4.89,0,0,1,4.88-4.88h1.95a4.9,4.9,0,0,1,4.88,4.88v2.93H60a3.93,3.93,0,0,1,3.91,3.9ZM25.81,35V26.19H17V35Zm0,11.71V36.93H17v9.76Zm0,10.74V48.64H17v8.79Zm2.93-45.88a1,1,0,0,0-1-1h-2a1,1,0,0,0-1,1v8.78a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1ZM37.52,35V26.19H27.76V35Zm0,11.71V36.93H27.76v9.76Zm0,10.74V48.64H27.76v8.79ZM49.24,35V26.19H39.48V35Zm0,11.71V36.93H39.48v9.76Zm0,10.74V48.64H39.48v8.79Zm2.93-45.88a1,1,0,0,0-1-1H49.24a1,1,0,0,0-1,1v8.78a1,1,0,0,0,1,1h1.95a1,1,0,0,0,1-1ZM60,35V26.19H51.19V35Zm0,11.71V36.93H51.19v9.76Zm0,10.74V48.64H51.19v8.79Z"
});

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 77 68",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.9a5648ee.svg";
export { ForwardRef as ReactComponent };